import styled from 'styled-components';
import { CaretDown } from '@hqo/react-components-library/dist/icons';
import { DIMENSIONS } from '@hqo/react-components-library/dist/utils';

interface LocationPickerContainerProps {
  isResourcesPage?: boolean;
  isFloorplanUi?: boolean;
}

export const LocationPickerContainer = styled.div<LocationPickerContainerProps>`
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  align-items: center;
  height: 36px;
  font-family: ${({ theme }) => theme.fonts.join()};
  font-size: 16px;
  background-color: ${({ theme }) => theme.colors.universal.white};
  color: ${({ theme }) => theme?.colors.greys.adminBlack};
  border: 1px solid ${({ theme }) => theme.colors.greys.adminGreyMedium};
  border-radius: ${({ isFloorplanUi }) => (isFloorplanUi ? '11px' : '4px')};
  cursor: pointer;
  /* The redesigned controls carry their glyphs in grey, keeping the location name the only black
     thing in the field. Only the injected svgs are hit — the caret is one too, as in the design. */
  ${({ isFloorplanUi, theme }) =>
    isFloorplanUi &&
    `svg {
      color: ${theme.colors.palette.systemGreyDark};
      flex-shrink: 0;
    }`}
  width: 413px;
  max-width: 50%;

  @media only screen and (max-width: ${DIMENSIONS.MEDIUM}) {
    width: 100%;
    max-width: initial;
    margin-bottom: 0;
  }
`;

export const LocationName = styled.div`
  font: 500 16px/22px ${({ theme }) => theme.fonts.join()};
  margin-right: auto;
  margin-left: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const CaretDownIcon = styled(CaretDown)`
  width: 10px;
  height: 5px;
`;
